import { gql } from '@apollo/client'

const MENU_DATA_DISH_FRAGMENT = gql`
  fragment MenuDataDishFragment on MenuDataDish {
    dishId
    dishName
    dishImportedPrice
    dishDescription
    menuTitlePath
    dishAddonDescriptors
    dishMiscDescriptors
  }
`

export default MENU_DATA_DISH_FRAGMENT
